module.exports = __webpack_public_path__ + "img/social-step-2.749f4944.svg";